import { Trans, useLingui } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import { useStripeSubscription } from 'src/api/queries';
import { NotificationBox } from 'src/components';
import { subscriptionHelpers } from 'src/utils/subscriptionHelpers';

import { MissingPaymentDetailsNotification } from './MissingPaymentDetailsNotification';

export const PaymentNotifications = () => {
  const { t } = useLingui();
  const subscription = useStripeSubscription();

  if (subscription.isPending || subscription.isError || !subscription.data) {
    return null;
  }

  if (
    !subscription.data.paymentInformation ||
    !subscription.data.paymentInformation.payment
  ) {
    return <MissingPaymentDetailsNotification />;
  }

  if (!subscriptionHelpers.isPaymentFailing(subscription.data)) {
    return null;
  }

  let paymentInterval = t`monthly`;
  if (subscription.data.paymentInformation.paymentInterval === 'annually') {
    paymentInterval = t`annual`;
  } else if (
    subscription.data.paymentInformation.paymentInterval === 'biennial'
  ) {
    paymentInterval = t`2-year`;
  }

  if (subscription.data.paymentInformation.requiresAction) {
    return (
      <NotificationBox
        title={t`Payment couldn't be authorized`}
        data-cy="subscription-manual-action-required-notification"
        variant="error"
      >
        <Typography variant="body-sm">
          <Trans>
            We couldn&apos;t process your {paymentInterval} payment. Please
            verify your payment method and reauthorise.
          </Trans>
        </Typography>
      </NotificationBox>
    );
  }

  return (
    <NotificationBox
      title={t`Automatic billing failed`}
      data-cy="subscription-billing-overdue"
      variant="error"
    >
      <Typography variant="body-sm">
        <Trans>
          We couldn&apos;t process your {paymentInterval} payment. Please update
          your payment details to keep using your subscription.
        </Trans>
      </Typography>
    </NotificationBox>
  );
};
